
import * as verilogGrammar from "../../../src/Renderer/VerilogComponent/VerilogGrammar.js";
import nearley from "nearley";
import { fix, parseFromFile } from "../../../src/Renderer/VerilogComponent/parser.js";
import { Record } from "../fable_modules/fable-library-js.5.13.0/Types.js";
import { bigint_type, list_type, option_type, array_type, int32_type, record_type, bool_type, string_type } from "../fable_modules/fable-library-js.5.13.0/Reflection.js";
import { CodeEditorOpen, VerilogInput_$reflection, ParserOutput_$reflection, ReplaceType } from "./VerilogTypes.js";
import { map } from "../fable_modules/fable-library-js.5.13.0/Array.js";
import { toText, join, printf, toFail, toConsole } from "../fable_modules/fable-library-js.5.13.0/String.js";
import { hasExtn, dirName, makeLoadedComponentFromCanvasData, readFilesFromDirectory, pathJoin, writeFile, tryReadFileSync, baseNameWithoutExtension } from "../Interface/FilesIO.js";
import { average, reverse, cons, head, tail, collect, mapIndexed, toArray, fold, last, sum, isEmpty, singleton, append, indexed, unzip, item, zip, filter, length, sort, map as map_1, ofArray, empty } from "../fable_modules/fable-library-js.5.13.0/List.js";
import { SimpleJson_tryParse } from "../Common/SimpleJson/SimpleJson.js";
import { Convert_fromJson } from "../Common/SimpleJson/Json.Converter.js";
import { createTypeInfo } from "../Common/SimpleJson/TypeInfo.Converter.js";
import { safeHash, equals, comparePrimitives, defaultOf, compare, Exception } from "../fable_modules/fable-library-js.5.13.0/Util.js";
import { defaultArg, value as value_4 } from "../fable_modules/fable-library-js.5.13.0/Option.js";
import { SheetInfo, CCForm, CustomComponentType, Memory1, InitMemData, ComponentType, Project } from "../Common/CommonTypes.js";
import { getSemanticErrors as getSemanticErrors_1 } from "./ErrorCheck.js";
import { Fable_SimpleJson_Json__Json_stringify_Static_4E60E31B } from "../Common/SimpleJson/Json.Converter.js";
import { fixCanvasState, createConnection, createComponent, createSheet } from "./SheetCreator.js";
import { minValue } from "../fable_modules/fable-library-js.5.13.0/Date.js";
import { map as map_2, ofList } from "../fable_modules/fable-library-js.5.13.0/Map.js";
import { compare as compare_1, fromInt32 } from "../fable_modules/fable-library-js.5.13.0/BigInt.js";
import { getOrderedCompLabels } from "../Simulator/CanvasExtractor.js";
import { mergeDependencies } from "../Simulator/GraphMerger.js";
import { runCanvasStateChecksAndBuildGraph } from "../Simulator/GraphBuilder.js";
import { List_distinct } from "../fable_modules/fable-library-js.5.13.0/Seq2.js";
import { buildFastSimulation } from "../Simulator/FastSim/FastBuild.js";
import { runFastSimulation } from "../Simulator/FastSim/FastRun.js";
import { StringModule_TrimEnd, MapModule_ValuesL } from "../Common/EEExtensions.js";
import { FastSimulation__ComponentOf_6546966D } from "../Simulator/SimTypes.js";
import { getArrayOfOutputs } from "../Simulator/FastSim/FastExtract.js";
import { getTimeMs } from "../Common/TimeHelpers.js";
import { toList } from "../fable_modules/fable-library-js.5.13.0/Seq.js";
import { rangeDouble } from "../fable_modules/fable-library-js.5.13.0/Range.js";
import { JsonHelpers_stateToJsonString } from "../Common/Helpers.js";




export class ExtraErrorInfoJson extends Record {
    constructor(Text$, Copy, Replace) {
        super();
        this.Text = Text$;
        this.Copy = Copy;
        this.Replace = Replace;
    }
}

export function ExtraErrorInfoJson_$reflection() {
    return record_type("TestParser.ExtraErrorInfoJson", [], ExtraErrorInfoJson, () => [["Text", string_type], ["Copy", bool_type], ["Replace", string_type]]);
}

export class ErrorInfoJson extends Record {
    constructor(Line, Col, Length, Message, ExtraErrors) {
        super();
        this.Line = (Line | 0);
        this.Col = (Col | 0);
        this.Length = (Length | 0);
        this.Message = Message;
        this.ExtraErrors = ExtraErrors;
    }
}

export function ErrorInfoJson_$reflection() {
    return record_type("TestParser.ErrorInfoJson", [], ErrorInfoJson, () => [["Line", int32_type], ["Col", int32_type], ["Length", int32_type], ["Message", string_type], ["ExtraErrors", option_type(array_type(ExtraErrorInfoJson_$reflection()))]]);
}

export function replaceTypeToString(replaceType) {
    switch (replaceType.tag) {
        case 1:
            return "Assignment";
        case 2:
            return replaceType.fields[0];
        case 3:
            return "NoReplace";
        default:
            return "IODeclaration";
    }
}

export function stringToReplaceType(replaceType) {
    switch (replaceType) {
        case "IODeclaration":
            return ReplaceType.IODeclaration;
        case "Assignment":
            return ReplaceType.Assignment;
        case "NoReplace":
            return ReplaceType.NoReplace;
        default:
            return new ReplaceType(/* Variable */ 2, [replaceType]);
    }
}

export function errorInfoToJson(errorInfo) {
    let matchValue;
    return new ErrorInfoJson(errorInfo.Line, errorInfo.Col, errorInfo.Length, errorInfo.Message, (matchValue = errorInfo.ExtraErrors, (matchValue != null) ? map((extraError) => (new ExtraErrorInfoJson(extraError.Text, extraError.Copy, replaceTypeToString(extraError.Replace))), matchValue) : undefined));
}

export function parseFile(src, dst) {
    let matchValue_1;
    toConsole(`[TEST] Parsing file ${baseNameWithoutExtension(src)}`);
    const input = tryReadFileSync(src);
    let patternInput;
    if (input.tag === 1) {
        patternInput = [input.fields[0], empty()];
    }
    else {
        let parseRes;
        const matchValue = SimpleJson_tryParse(parseFromFile(input.fields[0]));
        if (matchValue != null) {
            parseRes = Convert_fromJson(matchValue, createTypeInfo(ParserOutput_$reflection()));
        }
        else {
            throw new Exception("Couldn\'t parse the input JSON string because it seems to be invalid");
        }
        patternInput = [value_4(parseRes.Result), ofArray(value_4(parseRes.NewLinesIndex))];
    }
    const parse = patternInput[0];
    writeFile(dst, parse);
    return [(matchValue_1 = SimpleJson_tryParse(fix(parse)), (matchValue_1 != null) ? Convert_fromJson(matchValue_1, createTypeInfo(VerilogInput_$reflection())) : (() => {
        throw new Exception("Couldn\'t parse the input JSON string because it seems to be invalid");
    })()), patternInput[1]];
}

export const project = new Project("", "", "", empty());

export function getSemanticErrorsWithLoadedComponents(loadedComps, ast, linesIndex) {
    return getSemanticErrors_1(ast, linesIndex, CodeEditorOpen.NewVerilogFile, new Project(project.ProjectPath, project.OpenFileName, project.WorkingFileName, loadedComps));
}

export function getSemanticErrors(ast, linesIndex) {
    return getSemanticErrorsWithLoadedComponents(empty(), ast, linesIndex);
}

export function errorCheck(ast, linesIndex, src, dst) {
    const refFile = pathJoin(["./src/Renderer/VerilogComponent/test/ref/semantic", baseNameWithoutExtension(src) + ".json"]);
    const refOutput = tryReadFileSync(refFile);
    let refErrors;
    if (refOutput.tag === 1) {
        toConsole(`[TEST] Failed reading in reference output file ${refFile} ${refOutput.fields[0]}`);
        refErrors = empty();
    }
    else {
        const matchValue = SimpleJson_tryParse(refOutput.fields[0]);
        if (matchValue != null) {
            refErrors = Convert_fromJson(matchValue, createTypeInfo(list_type(ErrorInfoJson_$reflection())));
        }
        else {
            throw new Exception("Couldn\'t parse the input JSON string because it seems to be invalid");
        }
    }
    const outputErrors = map_1(errorInfoToJson, getSemanticErrors(ast, linesIndex));
    writeFile(dst, Fable_SimpleJson_Json__Json_stringify_Static_4E60E31B(outputErrors));
    if (Fable_SimpleJson_Json__Json_stringify_Static_4E60E31B(sort(outputErrors, {
        Compare: (x, y) => (compare(x, y) | 0),
    })) === Fable_SimpleJson_Json__Json_stringify_Static_4E60E31B(sort(refErrors, {
        Compare: (x_1, y_1) => (compare(x_1, y_1) | 0),
    }))) {
        return 1;
    }
    else {
        toConsole(`[${baseNameWithoutExtension(src)}] FAIL`);
        toConsole(`Output errors: ${outputErrors}`);
        toConsole(`Reference errors: ${refErrors}`);
        return 0;
    }
}

export function printSemanticErrors(src, errors) {
    const outputErrors = map_1(errorInfoToJson, errors);
    toConsole(`[TEST] couldn't parse input ${baseNameWithoutExtension(src)}`);
    toConsole(`Output errors: ${outputErrors}`);
    toConsole(`Output JSON: ${Fable_SimpleJson_Json__Json_stringify_Static_4E60E31B(outputErrors)}`);
}

export function semanticErrorTests(_arg) {
    const inputFiles = map_1((file) => pathJoin(["./src/Renderer/VerilogComponent/test/input/semantic", file]), readFilesFromDirectory("./src/Renderer/VerilogComponent/test/input/semantic"));
    console.log("Testing semantic error checks");
    const nrOfTestCases = length(inputFiles) | 0;
    const res_1 = length(filter((res) => (res === 1), map_1((tupledArg) => {
        const src = tupledArg[0];
        const dst = tupledArg[1];
        const patternInput = parseFile(src, dst);
        return errorCheck(patternInput[0], patternInput[1], src, dst) | 0;
    }, zip(inputFiles, map_1((file_1) => pathJoin(["./src/Renderer/VerilogComponent/test/output/semantic", baseNameWithoutExtension(file_1) + ".json"]), inputFiles))))) | 0;
    toConsole(`[TEST] ${res_1}/${nrOfTestCases} passed`);
    return [res_1, nrOfTestCases];
}

export class codegenInput extends Record {
    constructor(Label, Width, Values) {
        super();
        this.Label = Label;
        this.Width = (Width | 0);
        this.Values = Values;
    }
}

export function codegenInput_$reflection() {
    return record_type("TestParser.codegenInput", [], codegenInput, () => [["Label", string_type], ["Width", int32_type], ["Values", list_type(int32_type)]]);
}

export class codegenOutput extends Record {
    constructor(Label, Values) {
        super();
        this.Label = Label;
        this.Values = Values;
    }
}

export function codegenOutput_$reflection() {
    return record_type("TestParser.codegenOutput", [], codegenOutput, () => [["Label", string_type], ["Values", list_type(bigint_type)]]);
}

export class PortInfo extends Record {
    constructor(Label, Width) {
        super();
        this.Label = Label;
        this.Width = (Width | 0);
    }
}

export function PortInfo_$reflection() {
    return record_type("TestParser.PortInfo", [], PortInfo, () => [["Label", string_type], ["Width", int32_type]]);
}

export class Input extends Record {
    constructor(Inputs, Outputs, IsClocked, ModuleName) {
        super();
        this.Inputs = Inputs;
        this.Outputs = Outputs;
        this.IsClocked = IsClocked;
        this.ModuleName = ModuleName;
    }
}

export function Input_$reflection() {
    return record_type("TestParser.Input", [], Input, () => [["Inputs", list_type(codegenInput_$reflection())], ["Outputs", list_type(PortInfo_$reflection())], ["IsClocked", bool_type], ["ModuleName", string_type]]);
}

export function simulateAST(ast, src, dst, loadedComps) {
    let matchValue_1, matchValue_5;
    const cs = createSheet(ast, new Project(project.ProjectPath, project.OpenFileName, project.WorkingFileName, loadedComps), defaultOf(), (value) => {
    });
    const loadedComp = makeLoadedComponentFromCanvasData(cs[0], cs[1], "", minValue(), undefined, undefined)[0];
    const inputValuesFile_1 = tryReadFileSync(pathJoin([dirName(src), baseNameWithoutExtension(src) + ".json"]));
    let inputs;
    if (inputValuesFile_1.tag === 1) {
        inputs = toFail(`Couldn't open input data file ${inputValuesFile_1.fields[0]}`);
    }
    else {
        const matchValue = SimpleJson_tryParse(inputValuesFile_1.fields[0]);
        if (matchValue != null) {
            inputs = Convert_fromJson(matchValue, createTypeInfo(Input_$reflection()));
        }
        else {
            throw new Exception("Couldn\'t parse the input JSON string because it seems to be invalid");
        }
    }
    const ticks = (length(item(0, inputs.Inputs).Values) + 1) | 0;
    const cnt = createComponent(new ComponentType(/* CounterNoEnableLoad */ 38, [8]), "cnt");
    const patternInput_1 = unzip(map_1((inputPort) => {
        const rom = createComponent(new ComponentType(/* AsyncROM1 */ 39, [new Memory1(InitMemData.FromData, 8, inputPort.Width, ofList(map_1((tupledArg) => [fromInt32(tupledArg[0]), fromInt32(tupledArg[1])], indexed(inputPort.Values)), {
            Compare: (x, y) => (compare_1(x, y) | 0),
        }), undefined)]), "rom");
        return [rom, createConnection(item(0, cnt.OutputPorts), item(0, rom.InputPorts))];
    }, inputs.Inputs));
    const comps = patternInput_1[0];
    const verilog = new CustomComponentType(loadedComp.Name, getOrderedCompLabels(new ComponentType(/* Input1 */ 0, [0, undefined]), cs[0], cs[1]), getOrderedCompLabels(new ComponentType(/* Output */ 1, [0]), cs[0], cs[1]), loadedComp.Form, undefined, loadedComp.Description);
    const verilogComp = createComponent(new ComponentType(/* Custom */ 26, [verilog]), "verilog");
    const verilogConns = map_1((tupledArg_1) => createConnection(item(0, tupledArg_1[0].OutputPorts), tupledArg_1[1]), zip(comps, verilogComp.InputPorts));
    const patternInput_2 = unzip(map_1((tupledArg_2) => {
        const label = tupledArg_2[0];
        const out = createComponent(new ComponentType(/* Output */ 1, [label[1]]), label[0]);
        return [out, createConnection(tupledArg_2[1], item(0, out.InputPorts))];
    }, zip(verilog.OutputLabels, verilogComp.OutputPorts)));
    const outputs = patternInput_2[0];
    const outputCompIds = ofList(map_1((output) => [output.Label, output.Id], outputs), {
        Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
    });
    let topCanvas;
    const tupledArg_3 = [append(singleton(cnt), append(comps, append(singleton(verilogComp), outputs))), append(patternInput_1[1], append(verilogConns, patternInput_2[1]))];
    topCanvas = fixCanvasState(tupledArg_3[0], tupledArg_3[1]);
    let res;
    const matchValue_2 = mergeDependencies("test", (matchValue_1 = runCanvasStateChecksAndBuildGraph(topCanvas[0], topCanvas[1], List_distinct(append(ofArray([loadedComp, makeLoadedComponentFromCanvasData(topCanvas[0], topCanvas[1], "", minValue(), undefined, undefined)[0]]), loadedComps), {
        Equals: equals,
        GetHashCode: (x_2) => (safeHash(x_2) | 0),
    })), (matchValue_1.tag === 0) ? matchValue_1.fields[0] : toFail(printf("Wrong canvas state"))), topCanvas[0], topCanvas[1], List_distinct(append(singleton(loadedComp), loadedComps), {
        Equals: equals,
        GetHashCode: (x_3) => (safeHash(x_3) | 0),
    }));
    if (matchValue_2.tag === 1) {
        res = toFail(`wrong simulation graph - ${matchValue_2.fields[0]}`);
    }
    else {
        const matchValue_3 = buildFastSimulation(ticks, "wires", matchValue_2.fields[0]);
        if (matchValue_3.tag === 0) {
            const fs = matchValue_3.fields[0];
            runFastSimulation(undefined, ticks - 1, fs);
            res = MapModule_ValuesL(map_2((label_1, id) => {
                const matchValue_4 = FastSimulation__ComponentOf_6546966D(fs, [id, empty()]);
                if (matchValue_4 != null) {
                    return new codegenOutput(label_1, ofArray(getArrayOfOutputs(matchValue_4, 0, ticks)));
                }
                else {
                    return toFail(printf("What? output doesn\'t have a fastcomponent"));
                }
            }, outputCompIds));
        }
        else {
            res = toFail(printf("couldn\'t build simulation graph"));
        }
    }
    writeFile(dst, Fable_SimpleJson_Json__Json_stringify_Static_4E60E31B(res));
    const refFilePath = pathJoin(["./src/Renderer/VerilogComponent/test/ref/codegen", baseNameWithoutExtension(src)]) + ".json";
    const refFile = tryReadFileSync(refFilePath);
    const refOutput = map_1((out_2) => (new codegenOutput(out_2.Label.toLocaleUpperCase(), out_2.Values)), (refFile.tag === 0) ? ((matchValue_5 = SimpleJson_tryParse(refFile.fields[0]), (matchValue_5 != null) ? Convert_fromJson(matchValue_5, createTypeInfo(list_type(codegenOutput_$reflection()))) : (() => {
        throw new Exception("Couldn\'t parse the input JSON string because it seems to be invalid");
    })())) : toFail(printf("Couldn\'t open codegen reference output!")));
    if (equals(sort(res, {
        Compare: (x_4, y_4) => (compare(x_4, y_4) | 0),
    }), sort(refOutput, {
        Compare: (x_5, y_5) => (compare(x_5, y_5) | 0),
    }))) {
        return 1;
    }
    else {
        toConsole(`[${baseNameWithoutExtension(refFilePath)}] FAIL`);
        return 0;
    }
}

export function formatSimulationError(error) {
    return error.message;
}

export function runCodeGenTests(_arg) {
    const inputFiles = map_1((file) => pathJoin(["./src/Renderer/VerilogComponent/test/input/codegen/single", file]), filter((path) => hasExtn(".sv", path), readFilesFromDirectory("./src/Renderer/VerilogComponent/test/input/codegen/single")));
    const res_1 = length(filter((res) => (res === 1), map_1((tupledArg) => {
        const src = tupledArg[0];
        const dst = tupledArg[1];
        const patternInput = parseFile(src, dst);
        const ast = patternInput[0];
        const matchValue = getSemanticErrors(ast, patternInput[1]);
        if (isEmpty(matchValue)) {
            try {
                return simulateAST(ast, src, dst, empty()) | 0;
            }
            catch (error) {
                toConsole(`[TEST] couldn't simulate AST for ${baseNameWithoutExtension(src)}: ${formatSimulationError(error)}`);
                return 0;
            }
        }
        else {
            printSemanticErrors(src, matchValue);
            return 0;
        }
    }, zip(inputFiles, map_1((file_1) => pathJoin(["./src/Renderer/VerilogComponent/test/output/codegen", baseNameWithoutExtension(file_1) + ".json"]), inputFiles))))) | 0;
    const srcDirs = readFilesFromDirectory("./src/Renderer/VerilogComponent/test/input/codegen/multiple");
    const multRes = sum(map_1((dir) => {
        const modulePaths = filter((fName) => hasExtn(".sv", fName), map_1((file_2) => pathJoin(["./src/Renderer/VerilogComponent/test/input/codegen/multiple", dir, file_2]), sort(readFilesFromDirectory(pathJoin(["./src/Renderer/VerilogComponent/test/input/codegen/multiple", dir])), {
            Compare: (x, y) => (comparePrimitives(x, y) | 0),
        })));
        const topModulePath = last(modulePaths);
        const dst_1 = pathJoin(["./src/Renderer/VerilogComponent/test/output/codegen", baseNameWithoutExtension(topModulePath)]) + ".json";
        const loadedComps = fold((comps, file_3) => {
            const patternInput_1 = parseFile(file_3, dst_1);
            const ast_1 = patternInput_1[0];
            let cs;
            const matchValue_1 = getSemanticErrorsWithLoadedComponents(comps, ast_1, patternInput_1[1]);
            if (isEmpty(matchValue_1)) {
                cs = createSheet(ast_1, new Project(project.ProjectPath, project.OpenFileName, project.WorkingFileName, comps), defaultOf(), (value) => {
                });
            }
            else {
                printSemanticErrors(file_3, matchValue_1);
                cs = [empty(), empty()];
            }
            return append(comps, singleton(makeLoadedComponentFromCanvasData(cs[0], cs[1], ast_1.Module.ModuleName.Name, minValue(), undefined, undefined)[0]));
        }, empty(), modulePaths);
        const patternInput_3 = parseFile(topModulePath, dst_1);
        try {
            return simulateAST(patternInput_3[0], topModulePath, dst_1, loadedComps) | 0;
        }
        catch (error_1) {
            toConsole(`[TEST] couldn't simulate AST for ${baseNameWithoutExtension(topModulePath)}: ${formatSimulationError(error_1)}`);
            return 0;
        }
    }, srcDirs), {
        GetZero: () => 0,
        Add: (x_1, y_1) => ((x_1 + y_1) | 0),
    }) | 0;
    toConsole(`[TEST] ${res_1 + multRes}/${length(inputFiles) + length(srcDirs)} passed`);
    return (res_1 + multRes) | 0;
}

/**
 * Compile or run a verilog file with Icarus, writing stdout to dst.
 * 
 * This used to spawn the program here. That single call was the last thing dragging node's
 * child process module into the renderer bundle - and it is exactly the shape a bridge must not
 * offer, since "run this command with these arguments" is the whole capability back again.
 * (Spelled without the module name on purpose: grepping the built bundle for a stray require is
 * how this class of problem gets found, and a comment that matches the search is a false lead.)
 * Main runs it instead, from a closed pair of programs; see Bridge.runDevTool. Fire and forget,
 * as this always was: every caller ignored the result.
 */
export function executeCommand(command1, args1, dst) {
    window.issieBridge.build.runDevTool(command1,toArray(args1),defaultArg(dst, ""));
}

export function icarusCompile(src, dst, driver) {
    executeCommand("iverilog", ofArray(["-Wall", "-g", "2012", "-o", dst, "-s", "top_module", driver, src]), undefined);
}

export function icarusCompileTestCases() {
    map_1((filename) => {
        const srcFilePath = pathJoin(["./src/Renderer/VerilogComponent/test/input/codegen/single", filename]);
        const driverFilePath = pathJoin(["./src/Renderer/VerilogComponent/test/input/driver", filename]);
        icarusCompile(srcFilePath, pathJoin(["./src/Renderer/VerilogComponent/test/bin", baseNameWithoutExtension(filename)]), driverFilePath);
    }, filter((fName) => hasExtn(".sv", fName), readFilesFromDirectory("./src/Renderer/VerilogComponent/test/input/codegen/single")));
    map_1((dir) => {
        const srcFilePath_1 = pathJoin(["./src/Renderer/VerilogComponent/test/input/codegen/multiple", dir]) + "/*.sv";
        const driverFilePath_1 = pathJoin(["./src/Renderer/VerilogComponent/test/input/driver", dir]) + ".sv";
        icarusCompile(srcFilePath_1, pathJoin(["./src/Renderer/VerilogComponent/test/bin", dir]), driverFilePath_1);
    }, readFilesFromDirectory("./src/Renderer/VerilogComponent/test/input/codegen/multiple"));
}

export function icarusRun(src, dst) {
    executeCommand("vvp", singleton(src), dst);
}

export function icarusRunTestCases() {
    map_1((bin) => {
        icarusRun(pathJoin(["./src/Renderer/VerilogComponent/test/bin", bin]), pathJoin(["./src/Renderer/VerilogComponent/test/ref/codegen", bin]) + ".json");
    }, readFilesFromDirectory("./src/Renderer/VerilogComponent/test/bin"));
}

export function stringAppend(str1, str2) {
    return str2 + str1;
}

/**
 * Generate a top level module for a given DUT, return the Verilog module as a string
 * inputs stores the label and width of each input and output and the width and label of the output ports
 */
export function genDriver(inputs) {
    let inputArrayAssigns, forLoop, inputAssigns, arg_23;
    const inputLabels = map_1((input) => (new PortInfo(input.Label, input.Width)), inputs.Inputs);
    const cycles = length(item(0, inputs.Inputs).Values) | 0;
    return (((("module top_module;\n" + stringAppend("integer i_, j_;\n", stringAppend("bit clk;\n", join("", map_1((input_1) => {
        let arg_2, arg_3, arg_4;
        let str_1;
        const arg = (input_1.Width - 1) | 0;
        str_1 = toText(printf("  bit [%d:0] %s;\n"))(arg)(input_1.Label);
        return stringAppend((arg_2 = ((input_1.Width - 1) | 0), (arg_3 = (input_1.Label + "_array"), (arg_4 = ((cycles - 1) | 0), toText(printf("  bit [%d:0] %s [%d:0];\n"))(arg_2)(arg_3)(arg_4)))), str_1);
    }, append(inputLabels, inputs.Outputs)))))) + ((stringAppend("    $display(\"[\");\n", stringAppend("    end \n", stringAppend("      clk=!clk;\n", stringAppend("      #1;\n", stringAppend(`    repeat(${(cycles * 2) + 4}) begin
`, stringAppend("   clk=0;\n", "  initial begin\n")))))) + stringAppend("    $finish(0);\n", stringAppend("    $write(\"]\");\n", join("", mapIndexed((i, output) => {
        let arg_6, arg_7, arg_9, arg_10;
        const sep_1 = (i < (length(inputs.Outputs) - 1)) ? ", " : "";
        let str_21;
        const str_19 = toText(printf("    $write(\"{\\\"Label\\\": \\\"%s\\\", \\\"Values\\\": [\");\n"))(output.Label);
        str_21 = stringAppend((arg_6 = ((cycles - 1) | 0), (arg_7 = (output.Label + "_array"), toText(printf("    for(i_=0;i_<%d; i_=i_+1) begin $write(\"%%d, \", %s[i_]); end\n"))(arg_6)(arg_7))), str_19);
        return stringAppend((arg_9 = (output.Label + "_array"), (arg_10 = ((cycles - 1) | 0), toText(printf("    $display(\"%%d]}%s\", %s[%i]);\n"))(sep_1)(arg_9)(arg_10))), str_21);
    }, inputs.Outputs))))) + "  end\n")) + ((inputArrayAssigns = join("", map_1((input_2) => join("", mapIndexed((i_1, value) => {
        const arg_11 = input_2.Label + "_array";
        return toText(printf("      %s[%d] = %d\'d%d;\n"))(arg_11)(i_1)(input_2.Width)(value);
    }, input_2.Values)), inputs.Inputs)), (forLoop = toText(printf("    for(j_=0; j_<%d; j_=j_+1) begin\n"))(cycles), (inputAssigns = join("", map_1((input_3) => {
        const arg_17 = input_3.Label + "_array";
        return toText(printf("        %s=%s[j_];\n"))(input_3.Label)(arg_17);
    }, inputs.Inputs)), stringAppend("  end\n", stringAppend("end\n", stringAppend("      @(negedge clk);\n", stringAppend(join("", map_1((output_1) => {
        const arg_18 = output_1.Label + "_array";
        return toText(printf("        %s[j_]=%s;\n"))(arg_18)(output_1.Label);
    }, inputs.Outputs)), stringAppend("      #0.5;\n", stringAppend(inputAssigns, stringAppend(forLoop, stringAppend(inputArrayAssigns, "  initial begin\n"))))))))))))) + ((arg_23 = StringModule_TrimEnd([",", " "], join("", map_1((input_4) => toText(printf(".%s(%s), "))(input_4.Label)(input_4.Label), append(inputLabels, inputs.Outputs))) + (inputs.IsClocked ? ".clk(clk), " : "")), toText(printf("  %s dut (%s);\n"))(inputs.ModuleName)(arg_23)))) + "endmodule";
}

export const testInput = new Input(singleton(new codegenInput("in", 3, ofArray([7, 1, 3, 1, 0, 1, 2, 3, 4, 5]))), singleton(new PortInfo("out", 3)), false, "buffer");

export function genDriverFiles() {
    map_1((tupledArg) => {
        const driverCode = genDriver(tupledArg[0]);
        return writeFile(pathJoin(["./src/Renderer/VerilogComponent/test/input/driver", baseNameWithoutExtension(tupledArg[1])]) + ".sv", driverCode);
    }, map_1((filename) => {
        let matchValue;
        const refFile = tryReadFileSync(filename);
        return [(refFile.tag === 0) ? ((matchValue = SimpleJson_tryParse(refFile.fields[0]), (matchValue != null) ? Convert_fromJson(matchValue, createTypeInfo(Input_$reflection())) : (() => {
            throw new Exception("Couldn\'t parse the input JSON string because it seems to be invalid");
        })())) : toFail(printf("Couldn\'t open port info file for driver module generation %s"))(filename), filename];
    }, append(map_1((f) => pathJoin(["./src/Renderer/VerilogComponent/test/input/codegen/single", f]), filter((fName) => hasExtn("json", fName), readFilesFromDirectory("./src/Renderer/VerilogComponent/test/input/codegen/single"))), map_1((f_2) => pathJoin(["./src/Renderer/VerilogComponent/test/input/codegen/multiple", f_2]), filter((fName_1) => hasExtn("json", fName_1), collect((dir) => map_1((f_1) => pathJoin([dir, f_1]), readFilesFromDirectory(pathJoin(["./src/Renderer/VerilogComponent/test/input/codegen/multiple", dir]))), readFilesFromDirectory("./src/Renderer/VerilogComponent/test/input/codegen/multiple")))))));
}

export function runCompilerTests(_arg) {
    const filenames = map_1((file) => pathJoin(["./src/Renderer/VerilogComponent/test/input/valid", file]), readFilesFromDirectory("./src/Renderer/VerilogComponent/test/input/valid"));
    map_1((tupledArg) => parseFile(tupledArg[0], tupledArg[1]), zip(filenames, map_1((file_1) => pathJoin(["./src/Renderer/VerilogComponent/test/output/valid", baseNameWithoutExtension(file_1) + ".json"]), filenames)));
    console.log("Testing compiler error checks");
    semanticErrorTests(undefined);
    console.log("Testing code generation tests");
    runCodeGenTests(undefined);
}

export function unzip5(lst) {
    if (!isEmpty(lst)) {
        const patternInput = unzip5(tail(lst));
        return [append(singleton(head(lst)[0]), patternInput[0]), append(singleton(head(lst)[1]), patternInput[1]), append(singleton(head(lst)[2]), patternInput[2]), append(singleton(head(lst)[3]), patternInput[3]), append(singleton(head(lst)[4]), patternInput[4])];
    }
    else {
        return [empty(), empty(), empty(), empty(), empty()];
    }
}

export const dummyProject = new Project("", "", undefined, empty());

export function standardDev(list) {
    const count = length(list) | 0;
    const mean = sum(list, {
        GetZero: () => 0,
        Add: (x, y) => (x + y),
    }) / count;
    const meanOfSquaredDifferences = sum(map_1((x_1) => {
        const arg0__5 = x_1 - mean;
        return Math.pow(arg0__5, 2);
    }, list), {
        GetZero: () => 0,
        Add: (x_2, y_1) => (x_2 + y_1),
    }) / count;
    return Math.sqrt(meanOfSquaredDifferences);
}

export function unzip6(xs) {
    const tupledArg_2 = fold((tupledArg, tupledArg_1) => [cons(tupledArg_1[0], tupledArg[0]), cons(tupledArg_1[1], tupledArg[1]), cons(tupledArg_1[2], tupledArg[2]), cons(tupledArg_1[3], tupledArg[3]), cons(tupledArg_1[4], tupledArg[4]), cons(tupledArg_1[5], tupledArg[5])], [empty(), empty(), empty(), empty(), empty(), empty()], xs);
    return [reverse(tupledArg_2[0]), reverse(tupledArg_2[1]), reverse(tupledArg_2[2]), reverse(tupledArg_2[3]), reverse(tupledArg_2[4]), reverse(tupledArg_2[5])];
}

export function runPerformanceTests() {
    const files = filter((fName) => hasExtn(".sv", fName), readFilesFromDirectory("./src/Renderer/VerilogComponent/test/input/codegen/single"));
    const model = defaultOf();
    const dispatch = (value) => {
    };
    writeFile("./verilogPerformance.txt", join("", map_1((file) => {
        let input;
        const matchValue = tryReadFileSync(pathJoin(["./src/Renderer/VerilogComponent/test/input/codegen/single", file]));
        input = ((matchValue.tag === 0) ? matchValue.fields[0] : toFail(printf("Couldn\'t read file")));
        toConsole(printf("file: %A"))(file);
        const tupledArg = unzip6(map_1((_arg) => {
            const parseStart = getTimeMs();
            let patternInput;
            let parseRes;
            const matchValue_1 = SimpleJson_tryParse(parseFromFile(input));
            if (matchValue_1 != null) {
                parseRes = Convert_fromJson(matchValue_1, createTypeInfo(ParserOutput_$reflection()));
            }
            else {
                throw new Exception("Couldn\'t parse the input JSON string because it seems to be invalid");
            }
            patternInput = [value_4(parseRes.Result), ofArray(value_4(parseRes.NewLinesIndex))];
            const linesIndex = patternInput[1];
            let ast;
            const matchValue_2 = SimpleJson_tryParse(fix(patternInput[0]));
            if (matchValue_2 != null) {
                ast = Convert_fromJson(matchValue_2, createTypeInfo(VerilogInput_$reflection()));
            }
            else {
                throw new Exception("Couldn\'t parse the input JSON string because it seems to be invalid");
            }
            const parseEnd = getTimeMs();
            getSemanticErrors_1(ast, linesIndex, CodeEditorOpen.NewVerilogFile, dummyProject);
            const errorCheckEnd = getTimeMs();
            const patternInput_1 = createSheet(ast, dummyProject, model, dispatch);
            const synthesisEnd = getTimeMs();
            return [length(linesIndex), length(patternInput_1[0]), parseEnd - parseStart, errorCheckEnd - parseEnd, synthesisEnd - errorCheckEnd, synthesisEnd - parseStart];
        }, toList(rangeDouble(1, 1, 100))));
        return `${item(0, tupledArg[0])}, ${item(0, tupledArg[1])}, ${average(tupledArg[2], {
            GetZero: () => 0,
            Add: (x_1, y) => (x_1 + y),
            DivideByInt: (x, i) => (x / i),
        })}, ${average(tupledArg[3], {
            GetZero: () => 0,
            Add: (x_3, y_1) => (x_3 + y_1),
            DivideByInt: (x_2, i_1) => (x_2 / i_1),
        })}, ${average(tupledArg[4], {
            GetZero: () => 0,
            Add: (x_5, y_2) => (x_5 + y_2),
            DivideByInt: (x_4, i_2) => (x_4 / i_2),
        })}, ${average(tupledArg[5], {
            GetZero: () => 0,
            Add: (x_7, y_3) => (x_7 + y_3),
            DivideByInt: (x_6, i_3) => (x_6 / i_3),
        })}
`;
    }, files)));
    const arg_1 = join("", map_1((file_1) => {
        let input_4;
        const matchValue_9 = tryReadFileSync(pathJoin(["./src/Renderer/VerilogComponent/test/input/codegen/single", file_1]));
        input_4 = ((matchValue_9.tag === 0) ? matchValue_9.fields[0] : toFail(printf("Couldn\'t read file")));
        const tupledArg_1 = unzip(map_1((_arg_1) => {
            let patternInput_3;
            let parseRes_1;
            const matchValue_10 = SimpleJson_tryParse(parseFromFile(input_4));
            if (matchValue_10 != null) {
                parseRes_1 = Convert_fromJson(matchValue_10, createTypeInfo(ParserOutput_$reflection()));
            }
            else {
                throw new Exception("Couldn\'t parse the input JSON string because it seems to be invalid");
            }
            patternInput_3 = [value_4(parseRes_1.Result), ofArray(value_4(parseRes_1.NewLinesIndex))];
            let ast_1;
            const matchValue_11 = SimpleJson_tryParse(fix(patternInput_3[0]));
            if (matchValue_11 != null) {
                ast_1 = Convert_fromJson(matchValue_11, createTypeInfo(VerilogInput_$reflection()));
            }
            else {
                throw new Exception("Couldn\'t parse the input JSON string because it seems to be invalid");
            }
            const errorCheckEnd_1 = getTimeMs();
            const cs = createSheet(ast_1, dummyProject, model, dispatch);
            const synthesisEnd_1 = getTimeMs();
            return [length(cs[0]), synthesisEnd_1 - errorCheckEnd_1];
        }, toList(rangeDouble(1, 1, 100))));
        return `${item(0, tupledArg_1[0])}, ${average(tupledArg_1[1], {
            GetZero: () => 0,
            Add: (x_9, y_4) => (x_9 + y_4),
            DivideByInt: (x_8, i_4) => (x_8 / i_4),
        })}
`;
    }, files));
    toConsole(printf("%A"))(arg_1);
}

export const usedHeapSize = (performance.memory.usedJSHeapSize) / 1000000;

export const heapLimitSize = (performance.memory.jsHeapSizeLimit) / 1000000;

export const heapUsage = (usedHeapSize / heapLimitSize) * 100;

export function mbHeap() {
    return (performance.memory.usedJSHeapSize) / 1000000;
}

/**
 * Returns (before, after) heap in MB, with a forced GC before each snapshot
 */
export function measureMem(action) {
    const before = mbHeap();
    action();
    return [before, mbHeap()];
}

export function unzip4(xs) {
    const tupledArg_2 = fold((tupledArg, tupledArg_1) => [cons(tupledArg_1[0], tupledArg[0]), cons(tupledArg_1[1], tupledArg[1]), cons(tupledArg_1[2], tupledArg[2]), cons(tupledArg_1[3], tupledArg[3])], [empty(), empty(), empty(), empty()], xs);
    return [reverse(tupledArg_2[0]), reverse(tupledArg_2[1]), reverse(tupledArg_2[2]), reverse(tupledArg_2[3])];
}

export function runMemoryTests() {
    const files = filter((fName) => hasExtn(".sv", fName), readFilesFromDirectory("./src/Renderer/VerilogComponent/test/input/codegen/single"));
    const model = defaultOf();
    const dispatch = (value) => {
    };
    writeFile("./verilogMemory.csv", "file, lines, components, parseNetMB, errorCheckNetMB, synthesisNetMB, totalMB\n" + join("", map_1((file) => {
        let matchValue_6;
        let input;
        const matchValue = tryReadFileSync(pathJoin(["./src/Renderer/VerilogComponent/test/input/codegen/single", file]));
        input = ((matchValue.tag === 0) ? matchValue.fields[0] : toFail(printf("Couldn\'t read file")));
        const arg = baseNameWithoutExtension(file);
        toConsole(printf("[TEST] Measuring memory for %s"))(arg);
        const patternInput_3 = unzip4(map_1((i) => {
            (global.gc)();
            const patternInput = measureMem(() => {
                let parseRes;
                const matchValue_1 = SimpleJson_tryParse(parseFromFile(input));
                if (matchValue_1 != null) {
                    parseRes = Convert_fromJson(matchValue_1, createTypeInfo(ParserOutput_$reflection()));
                }
                else {
                    throw new Exception("Couldn\'t parse the input JSON string because it seems to be invalid");
                }
                const parse = value_4(parseRes.Result);
                ofArray(value_4(parseRes.NewLinesIndex));
                const matchValue_2 = SimpleJson_tryParse(fix(parse));
                if (matchValue_2 != null) {
                    Convert_fromJson(matchValue_2, createTypeInfo(VerilogInput_$reflection()));
                }
                else {
                    throw new Exception("Couldn\'t parse the input JSON string because it seems to be invalid");
                }
            });
            const parseBefore = patternInput[0];
            let parseRes_1;
            const matchValue_3 = SimpleJson_tryParse(parseFromFile(input));
            if (matchValue_3 != null) {
                parseRes_1 = Convert_fromJson(matchValue_3, createTypeInfo(ParserOutput_$reflection()));
            }
            else {
                throw new Exception("Couldn\'t parse the input JSON string because it seems to be invalid");
            }
            const parse_1 = value_4(parseRes_1.Result);
            const linesIndex_1 = ofArray(value_4(parseRes_1.NewLinesIndex));
            let ast;
            const matchValue_4 = SimpleJson_tryParse(fix(parse_1));
            if (matchValue_4 != null) {
                ast = Convert_fromJson(matchValue_4, createTypeInfo(VerilogInput_$reflection()));
            }
            else {
                throw new Exception("Couldn\'t parse the input JSON string because it seems to be invalid");
            }
            const patternInput_1 = measureMem(() => {
                getSemanticErrors_1(ast, linesIndex_1, CodeEditorOpen.NewVerilogFile, dummyProject);
            });
            const patternInput_2 = measureMem(() => {
                JsonHelpers_stateToJsonString(createSheet(ast, dummyProject, model, dispatch), undefined, new SheetInfo(new CCForm(/* Verilog */ 4, ["name"]), undefined, undefined, undefined, undefined));
            });
            const synthAfter = patternInput_2[1];
            return [patternInput[1] - parseBefore, patternInput_1[1] - patternInput_1[0], synthAfter - patternInput_2[0], synthAfter - parseBefore];
        }, toList(rangeDouble(1, 1, 10))));
        const synthNets = patternInput_3[2];
        const parseNets = patternInput_3[0];
        const errorNets = patternInput_3[1];
        const avg = (list_2) => average(list_2, {
            GetZero: () => 0,
            Add: (x_1, y) => (x_1 + y),
            DivideByInt: (x, i_1) => (x / i_1),
        });
        let parseRes_2;
        const matchValue_5 = SimpleJson_tryParse(parseFromFile(input));
        if (matchValue_5 != null) {
            parseRes_2 = Convert_fromJson(matchValue_5, createTypeInfo(ParserOutput_$reflection()));
        }
        else {
            throw new Exception("Couldn\'t parse the input JSON string because it seems to be invalid");
        }
        const parse_2 = value_4(parseRes_2.Result);
        const linesIndex_2 = ofArray(value_4(parseRes_2.NewLinesIndex));
        const cs_1 = createSheet((matchValue_6 = SimpleJson_tryParse(fix(parse_2)), (matchValue_6 != null) ? Convert_fromJson(matchValue_6, createTypeInfo(VerilogInput_$reflection())) : (() => {
            throw new Exception("Couldn\'t parse the input JSON string because it seems to be invalid");
        })()), dummyProject, model, dispatch);
        const lineCount = length(linesIndex_2) | 0;
        const compCount = length(cs_1[0]) | 0;
        const arg_1 = baseNameWithoutExtension(file);
        toConsole(printf("[TEST] %s: %d lines, %d components"))(arg_1)(lineCount)(compCount);
        const arg_4 = avg(parseNets);
        const arg_5 = standardDev(parseNets);
        toConsole(printf("  parse net:      avg=%.3f MB  stddev=%.3f"))(arg_4)(arg_5);
        const arg_6 = avg(errorNets);
        const arg_7 = standardDev(errorNets);
        toConsole(printf("  error check net: avg=%.3f MB  stddev=%.3f"))(arg_6)(arg_7);
        const arg_8 = avg(synthNets);
        const arg_9 = standardDev(synthNets);
        toConsole(printf("  synthesis net:   avg=%.3f MB  stddev=%.3f"))(arg_8)(arg_9);
        toConsole(printf("mbHeap heap: %A"))(usedHeapSize);
        toConsole(printf("heap limit: %A"))(heapLimitSize);
        const arg_12 = baseNameWithoutExtension(file);
        const arg_15 = avg(parseNets);
        const arg_16 = avg(errorNets);
        const arg_17 = avg(synthNets);
        const arg_18 = avg(patternInput_3[3]);
        return toText(printf("%s, %d, %d, %.6f, %.6f, %.6f, %.6f\n"))(arg_12)(lineCount)(compCount)(arg_15)(arg_16)(arg_17)(arg_18);
    }, files)));
    console.log("Memory tests done");
}

